import { useQuery } from 'react-query';
import { getExistingSalePoints } from '../utils/api/salePointApi';
/**
 * Only used internally for type check in this module,
 * because the properties is not correctly formatted.
 * */
var isSchool = function (salePoint) { return !!salePoint.department
    || !!salePoint.shortname
    || !!salePoint.shortName; };
var formatZipCode = function (salePoint) {
    var zipCode = salePoint.zipCode || salePoint.zip_code;
    if (zipCode) {
        return zipCode;
    }
    var id = salePoint.zipCodeId || salePoint.zip_code_id;
    return id ? {
        id: id,
        city: salePoint.city,
    } : undefined;
};
var formatSalePoint = function (salePoint) {
    if (isSchool(salePoint)) {
        return {
            id: salePoint.id,
            name: salePoint.name,
            shortName: salePoint.shortName || salePoint.shortname || salePoint.name,
            address: salePoint.address || '',
            department: salePoint.department,
            educationGrade: salePoint.educationGrade || salePoint.education_grade || '',
            zipCode: formatZipCode(salePoint),
        };
    }
    return {
        id: salePoint.id,
        salePoint: salePoint.salePoint || salePoint.sale_point,
        zipCode: formatZipCode(salePoint),
    };
};
var useListMySalePoints = function () {
    var _a;
    var _b = useQuery(['salePoints'], getExistingSalePoints, { staleTime: 3600000 }), isLoading = _b.isLoading, data = _b.data, error = _b.error, refetch = _b.refetch;
    return {
        isLoading: isLoading,
        error: error !== null && error !== void 0 ? error : undefined,
        salePoints: (_a = data === null || data === void 0 ? void 0 : data.map(formatSalePoint)) !== null && _a !== void 0 ? _a : [],
        reFetch: function () { return refetch(); },
    };
};
export default useListMySalePoints;
